import type { Theme } from '@mui/material';

export const styles = {
  wrapper: {
    overflowY: 'auto',
    position: 'absolute',
    left: '2rem',
    right: 0,
    bottom: 0,
    top: '1rem',
    pr: 3.5,
    pb: 2,
  },

  headerWrapper: (theme: Theme) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: theme.colors.white,
  }),

  panel: (theme: Theme) => ({
    margin: 'auto',
    textAlign: 'center',
    minWidth: '20rem',
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: '0.5rem',
    padding: '2rem',
  }),

  reportAnnotation: (theme: Theme) => ({
    color: theme.colors.error[600],
    pb: 4,
  }),
};
